import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch,Route } from 'react-router-dom'
import App from './App';
import Dashboard from './admin/dashboard';
import Userlist from './admin/userlist';
import UserAdd from './admin/user-add';
import Insights from './admin/insights';
import NewInsights from './admin/newInsights'
import CareerTracks from './ivano/careerTracks'

import Courses from './ivano/courses'
import Experts from './ivano/experts'
import Insightss from './ivano/insights'

import { messaging } from './firebase';
import Home from './home/home';
import Testimonials from './admin/testimonials';
import NewTestimonials from './admin/newTestimonials'
import Stories from './admin/stories';
import NewStories from './admin/newStories'
import NewStoriesEditor from './admin/newStoriesEditor'
import Profile from './ivano/profile';
import LostPassword from './ivano/lostPassword';
import MyAccount from './ivano/my-account';
import ExpertsDetails from './ivano/experts-details';
import InsightsDetails from './ivano/insights-details'
import CourseDetails from './ivano/course-details'
import FreeAssesment from './ivano/free-assesment'

import careerTracksSave  from './CareerTracks/career-tracks-save'
import newCourse  from './CareerTracks/newCourse'
import AssesmentApply from './ivano/assesment-apply'
import AssesmentPersonna from './ivano/assessment-personna'
import AssesmentGoal from './ivano/assessment-goal'
import AssesmentApply1 from './ivano/assesment-apply1'
import AssesmentApply2 from './ivano/assesment-apply2'
import AssesmentApply3 from './ivano/assesment-apply3'
import AssesmentApply4 from './ivano/assesment-apply4'
import AssesmentApply5 from './ivano/assesment-apply5'
import About from './ivano/about'
import Contact from './ivano/contact'
import UserDashboard from './ivano/dashboard'
import PrivacyPolicy from './ivano/privacy-policy'
import UserProfile from './ivano/userProfile'

import Skills from './admin/skills';
import NewSkill from './admin/newSkill';
import Expertise from './admin/expertise';
import NewExpertise from './admin/newExpertise';
import Education from './admin/education';
import NewEducation from './admin/newEducation';
import Experience from './admin/experience';
import NewExperience from './admin/newExperience';
import PriceRange from './admin/priceRange';
import NewPriceRange from './admin/newPriceRange';
import Personna from './admin/personna';
import NewPersonna from './admin/newPersonna';
import Institution from './admin/institution';
import NewInstitution from './admin/newInstitution';
import StoryCategory from './admin/storyCategory';
import NewStoryCategory from './admin/newStoryCategory';
import Goals from './admin/goals';
import NewGoals from './admin/newGoals';
import Country from './admin/country';
import NewCountry from './admin/newCountry';
import ModeOfLearning from './admin/modeOfLearning';
import Report from './admin/userReport';
import NewModeOfLearning from './admin/newModeOfLearning';

ReactDOM.render((
  <Router>
  <Switch>  
  <Route exact path="/" component={Home} />
  <Route path="/dashboard" component={Dashboard} exact />
	<Route path="/userlist" component={Userlist} />
	<Route path="/userAdd" component={UserAdd} />
  <Route path="/insights" component={Insights} />
  <Route path="/newInsights/keyId=:key" component={NewInsights} />
  <Route path="/careerTracks" component={CareerTracks} />
	<Route path="/courses" component={Courses} /> 
  <Route path="/experts" component={Experts} />
  	<Route path="/insightss" component={Insightss} />
  <Route path="/testimonials" component={Testimonials} />
  <Route path="/newTestimonials/keyId=:key" component={NewTestimonials} />
  <Route path="/stories" component={Stories} />
  <Route path="/newStories/keyId=:key" component={NewStories} />
  <Route path="/newStoriesEditor/keyId=:key" component={NewStoriesEditor} />
  <Route path="/profile" component={Profile} />
	<Route path="/lost-password" component={LostPassword} />
	<Route path="/my-account" component={MyAccount} /> 
	<Route path="/experts-details" component={ExpertsDetails} />
	<Route path="/insights-details" component={InsightsDetails} /> 
	<Route path="/course-details/id=:key" component={CourseDetails} /> 
	<Route path="/free-assesment" component={FreeAssesment} /> 
  <Route path="/career-tracks" component={careerTracksSave} /> 
  <Route path="/newCourse/keyId=:key" component={newCourse} /> 
  <Route path="/assesment/apply" component={AssesmentApply} />
  <Route path="/assesment/personna/id=:key" component={AssesmentPersonna} />
  <Route path="/assesment/goal/id=:key" component={AssesmentGoal} />
	<Route path="/assesment/apply-1/id=:key" component={AssesmentApply1} />
	<Route path="/assesment/apply-2/id=:key" component={AssesmentApply2} />
	<Route path="/assesment/apply-3/id=:key" component={AssesmentApply3} />
	<Route path="/assesment/apply-4/id=:key" component={AssesmentApply4} />
  <Route path="/assesment/apply-5" component={AssesmentApply5} />
	
	<Route path="/about" component={About} />
	<Route path="/contact" component={Contact} />
	<Route path="/user-dashboard" component={UserDashboard} />
	<Route path="/privacy-policy" component={PrivacyPolicy} />
  <Route path="/skills" component={Skills} />
  <Route path="/newSkill" component={NewSkill} />
  <Route path="/expertise" component={Expertise} />
  <Route path="/newExpertise" component={NewExpertise} />
  <Route path="/education" component={Education} />
  <Route path="/newEducation" component={NewEducation} />
  <Route path="/experience" component={Experience} />
  <Route path="/newExperience" component={NewExperience} />
  <Route path="/priceRange" component={PriceRange} />
  <Route path="/newPriceRange" component={NewPriceRange} />
  <Route path="/goals" component={Goals} />
  <Route path="/newGoals" component={NewGoals} />
  <Route path="/personna" component={Personna} />
  <Route path="/newPersonna" component={NewPersonna} />
  <Route path="/institution" component={Institution} />
  <Route path="/newInstitution" component={NewInstitution} />
  <Route path="/storyCategory" component={StoryCategory} />
  <Route path="/newStoryCategory" component={NewStoryCategory} />
  <Route path="/country" component={Country} />
  <Route path="/newCountry" component={NewCountry} />
  <Route path="/modeOfLearning" component={ModeOfLearning} />
  <Route path="/userReport" component={Report} />
  <Route path="/newModeOfLearning" component={NewModeOfLearning} />
  <Route path="/user-profile" component={UserProfile} /> ,
  </Switch>
</Router>
), document.getElementById('root'));


// logging our messaging notification
messaging.onMessage(payload => {
  console.log(payload);
})



// WEBPACK FOOTER //
// ./src/index.js